import CircleLoaderImage from '@/images/CircleLoader.json';
import Lottie from 'react-lottie';

const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: CircleLoaderImage,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice',
    },
};

interface Props {
    height?: string;
    width?: string;
}

export const CircleLoader = ({ height, width }: Props) => <Lottie options={defaultOptions} height={height} width={width} />;
